import VuexORM from "@vuex-orm/core";
import { ticketEntity } from "../../common/model/entity/ticket-entity";
import { ticketCommentEntity } from "../../common/model/entity/ticket-comment-entity";
import { clientEntity } from "../../common/model/entity/client-entity";
import { minimizedItemEntity } from "../../common/model/entity/minimized-item-entity";
import { clientLocationEntity } from "../../common/model/entity/client-location-entity";
import { clientWebDomainEntity } from "../../common/model/entity/client-web-domain-entity";
import { clientTypeEntity } from "../../common/model/entity/client-types-entity";
import { commentAttachmentEntity } from "../../common/model/entity/comment-attachment-entity";
import { contactEntity } from "../../common/model/entity/contact-entity";
import { contactViewingEntity } from "../../common/model/entity/contact-viewing-entity";
import {
  ticketStatusEntity,
  ticketTypeEntity,
} from "../../common/model/entity/enum-entities";
import { customStatusEntity } from "../../common/model/entity/custom-status-entity";
import { tagEntity } from "../../common/model/entity/tag-entity";
import { ticketTypeSettingEntity } from "../../common/model/entity/ticket-type-setting-entity";
import { technicianEntity } from "../../common/model/entity/technician-entity";
import { formEntity } from "../../common/model/entity/form-entity";
import { technicianGroupEntity } from "../../common/model/entity/technician-group-entity";
import { emailConfigurationEntity } from "../../common/model/entity/email-configuration-list-entity";
import { documentEntity } from "../../common/model/entity/document-entity";
import { invoiceEntity } from "../../common/model/entity/invoice-entity";
import { ticketSettingEntity } from "../../common/model/entity/ticket-setting-entity";
import { contactTagEntity } from "../../common/model/entity/contact-tag-entity";
import { projectEntity } from "../../common/model/project/project-entity";
import { projectTypeEntity } from "../../common/model/project/project-type-entity";

export const database = new VuexORM.Database();
database.register(ticketEntity);
database.register(projectEntity);
database.register(projectTypeEntity);
database.register(formEntity);
database.register(ticketStatusEntity);
database.register(customStatusEntity);
database.register(ticketCommentEntity);
database.register(minimizedItemEntity);
database.register(clientEntity);
database.register(clientLocationEntity);
database.register(clientWebDomainEntity);
database.register(clientTypeEntity);
database.register(commentAttachmentEntity);
database.register(contactEntity);
database.register(contactViewingEntity);
database.register(technicianEntity);
database.register(technicianGroupEntity);
database.register(emailConfigurationEntity);
database.register(documentEntity);
database.register(invoiceEntity);
database.register(ticketSettingEntity);
database.register(contactTagEntity);
database.register(ticketTypeEntity);
database.register(tagEntity);
database.register(ticketTypeSettingEntity);
